import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const MediaMentions = ({ mentions }) => {
  return (
    <div className="bg-card rounded-2xl p-8 shadow-warm">
      <div className="text-center mb-8">
        <h2 className="font-serif text-3xl font-semibold text-foreground mb-3">
          Featured In
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Recognized by local media and food critics for our authentic Italian craftsmanship and community dedication
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {mentions?.map((mention, index) => (
          <a
            key={index}
            href={mention?.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-background rounded-lg p-6 border border-border hover:border-primary hover:shadow-warm transition-all duration-300"
          >
            <div className="flex items-start gap-4">
              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
                <Image
                  src={mention?.logo}
                  alt={mention?.logoAlt}
                  className="w-full h-full object-contain p-2"
                />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors">
                    {mention?.publication}
                  </h3>
                  <Icon name="ExternalLink" size={14} color="var(--color-muted-foreground)" />
                </div>
                <p className="text-sm text-muted-foreground mb-2">{mention?.date}</p>
                <p className="text-sm text-foreground leading-relaxed">{mention?.excerpt}</p>
                {mention?.quote && (
                  <blockquote className="mt-3 pl-4 border-l-2 border-primary text-sm italic text-muted-foreground">
                    "{mention?.quote}"
                  </blockquote>
                )}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default MediaMentions;